import { useMemo } from "react";

import { getState } from "../../../../state/store";
import { selectAppTypes, selectMarkets } from "../../../../state/selectors";

import { appTypesNames, appApplicationGroups } from "../../../../consts";
import { appsUtil, arrayUtil } from "../../../../utils";

export const useGetAdminRoleConfigOptions = ({ selectedApplications, setSelectedMarkets }) => {
  const userApps = selectAppTypes()(getState()) ?? [];
  const marketConfigs = selectMarkets()(getState()) ?? [];

  const appOptions = useMemo(() => {
    const availableApps = userApps
      .filter((app) => app !== appTypesNames.allApps)
      .map((app) => {
        return { id: app, value: appsUtil.getAppName(app) };
      });

    return availableApps;
  }, [userApps]);

  const marketOptions = useMemo(() => {
    const selectedApplicationIds = selectedApplications?.map((app) => app.id);
    let markets = marketConfigs;

    markets = marketConfigs.filter((marketConfig) =>
      arrayUtil.includesSome(marketConfig?.activeAppTypes, selectedApplicationIds)
    );

    const options = markets.map((marketConfig) => {
      return { id: marketConfig?.id, value: marketConfig?.id };
    });

    updateSelectedMarkets(options);

    return options;
  }, [selectedApplications, marketConfigs]);

  const roleOptions = useMemo(() => {
    const allOptions = appApplicationGroups.map((item) => {
      return { id: item.group, value: item.value };
    });

    return allOptions;
  }, []);

  function updateSelectedMarkets(marketOptions) {
    const markteOptionsIds = marketOptions.map((opt) => opt.id);
    setSelectedMarkets((prev) => prev.filter((market) => markteOptionsIds.includes(market.id)));
  }

  return { appOptions, marketOptions, roleOptions };
};
